import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import PatientsGroupsCreateBySelection from './PatientsGroupsCreateBySelection';
import { Size } from '../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

const PatientsGroupsCreateBySelectionModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSuccess,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.LG}>
			<Modal.Header title='component.groupMsgs.createGroupBySelection' />
			<Modal.Content>
				<PatientsGroupsCreateBySelection onSuccess={onSuccess} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientsGroupsCreateBySelectionModal;
